import { render, staticRenderFns } from "./feedback_detail.vue?vue&type=template&id=3c68e40e&scoped=true&"
import script from "./feedback_detail.vue?vue&type=script&lang=ts&"
export * from "./feedback_detail.vue?vue&type=script&lang=ts&"
import style0 from "./feedback_detail.vue?vue&type=style&index=0&id=3c68e40e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68e40e",
  null
  
)

export default component.exports